import { Card, Row } from 'antd'
import CustomBreadCrumb from 'components/Common/CustomBreadCrumb'
import PageTitle from 'elements/PageTitle'
import React from 'react'

function PageCover({
  children,
  breadCrumb = [{ text: 'BreadCrumbs' }],
  title = 'title',
  subtitle = 'subtitle',
  color = '#ff9935',
  iconType = 'fire',
}) {
  //
  return (
    <div className="space-y-2">
      <Card>
        <Row>
          <CustomBreadCrumb items={breadCrumb} />
          <PageTitle {...{ title, subtitle, color, iconType }} />
        </Row>
      </Card>
      <Row>
        <Card>{children}</Card>
      </Row>
    </div>
  )
}

export default PageCover
